import React, { Component } from 'react';
import ReactModal from 'react-modal';

import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import styled from 'styled-components';

// icon imports
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

// table imports
import { withStyles } from '@material-ui/core/styles';

// material ui core imports
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

// moment utils for MuiPickersUtilsProvider
import MomentUtils from '@date-io/moment';
// material ui pickers
import {
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

// material ui core imports
import {
  CircularProgress,
  Button,
  IconButton,
  Grid
} from '@material-ui/core';

// component imports
import {
  RegularCard,
  ItemGrid,
  CustomInput,
} from "../../components";

// reducer imports

import {
  loadData,
  createNewData,
  editData,
  deleteData,
} from './reducer/actions';

import { Redirect } from "react-router-dom";

// modal styles
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 20px;
  border-bottom: 1px solid rgba(153, 153, 153, 0.7);
`
const ModalContent = styled.div`
  position: relative;
  padding: 20px 20px;
  overflow: hidden;
  padding-bottom: 20px;
  line-height: 50px;
`
const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid rgba(153, 153, 153, 0.7);
`
// modal style sheets
const customModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 102, 128, 0.5)'
  },
  content: {
    top: 'calc(50% + 30px)',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px !important',
    width: '572px'
  }
};

const CustomTableCell = withStyles(theme => ({
  head: {
    textAlign: 'center'
  },
  body: {
    fontSize: 16,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '230px',
  },
}))(TableCell);

// You wanna buy some death sticks?
// You don't want to sell me death sticks.
// I don't wanna sell you death sticks.
// You want to go home and rethink your life.
// I want to go home, and...rethink my life...

// TODO: determine the best way to input the time of day
// probably a Time Picker, and then whenever Edit/Create is pressed
// Convert it to just the needed numbers

// TODO: determine how best to pull JSON into Firebase Functions Index
// TODO: implement other two functions
// TODO: update packages, maybe, so it stops yelling at you

// class declaration
class Automation extends Component {

  // constructor
  constructor (props) {
    super(props);

    this.state = {
      // for filling out modal info
      abbreviation: '',
      name: '',
      archiveCount: 0,
      apiURL: '',
      timing: 0,
      // for showing the right version of the modal
      showModal: false,
      isEditing: false,
      // contains hash of dataset being edited
      editingData: ''
    };
  }

  // load data in
  componentDidMount() {
    this.props.loadData();
  }

  // on successful create/edit, close modal
  _onSuccess () {
    this.setState({ showModal: false });
  }

  // on unsuccessful create/edit, close modal and log error
  _onError (error) {
    this.setState({ showModal: false });
    console.log(error);
  }

  // set deletion of data
  _onDeleteData (id) {
    this.props.deleteData(
      id, this._onSuccess.bind(this),
      this._onError.bind(this));
  }

  // called when Edit Icon Button is pressed
  initEditData (id) {
    // get API from redux state
    const { apis } = this.props;
    // get the current dataset
    const curData = apis[id];
    // set state
    this.setState({
      abbreviation: curData.abrv,
      name: curData.name,
      archiveCount: curData.archiveCount,
      apiURL: curData.apiURL,
      timing: curData.timing,
      isEditing: true,
      editingData: id,
      showModal: true
    });
  }

  // called when the modal's Edit button is pressed
  _onEditData (id) {
    // assemble state into an object
    const data = {
      abrv: this.state.abbreviation,
      name: this.state.name,
      archiveCount: Number(this.state.archiveCount),
      apiURL: this.state.apiURL,
      timing: Number(this.state.timing),
      id: id
    };
    // call edit
    this.props.editData(id, data,
      this._onSuccess.bind(this), this._onError.bind(this)
    );
  }

  // called on pressing Create on the modal
  _onCreateNewData () {
    this.props.createNewData({
      abrv: this.state.abbreviation,
      name: this.state.name,
      archiveCount: Number(this.state.archiveCount),
      apiURL: this.state.apiURL,
      timing: Number(this.state.timing),
    }, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // show modal to Add New data
  _onShowModal () {
    this.setState({
      abbreviation: '',
      name: '',
      archiveCount: 0,
      apiURL: '',
      timing: 0,
      showModal: true,
      isEditing: false,
    })
  }

  // close the modal
  _onCloseModal () {
    this.setState({ showModal: false });
  }

  // render the Create/Edit Data Modal
  renderModal() {
    // if Show Modal is not set to true, return nothing.
    if (!this.state.showModal) {
      return null;
    }
    // otherwise, return the modal
    return (
      <ReactModal isOpen={this.state.showModal}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={this.state.isEditing ? 'Edit API' : 'Add API'}
        ariaHideApp={false}
        style={customModalStyles}
      >
        <ModalHeader>
          {this.state.isEditing ? 'Edit API' : 'Add API'}
        </ModalHeader>
        <ModalContent>
          <Grid container>
            {/* Set abbreviation for the data */}
            {/* Will use this as its reference point in the backend */}
            <ItemGrid xs={12}>
              <CustomInput
                labelText='Abbreviation of the lotto, where data will be stored'
                id='abbreviation'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.abbreviation,
                  onChange: (e)=>this.setState({ abbreviation: e.target.value })
                }}
              />
            </ItemGrid>
            {/* Name - how the dataset should be referred to in-app */}
            <ItemGrid xs={12}>
              <CustomInput
                labelText='Name: Printable Name of the Lotto'
                id='name'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.name,
                  onChange: (e)=>this.setState({ name: e.target.value })
                }}
              />
            </ItemGrid>
            {/* Max number of maintained past data sets */}
            <ItemGrid xs={12}>
              <CustomInput
                labelText='Archive Count: Number of past lotto pulls to keep in database'
                id='archiveCount'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.archiveCount,
                  onChange: (e)=>this.setState({ archiveCount: Number(e.target.value) })
                }}
              />
            </ItemGrid>
            {/* The URL to pull data from */}
            <ItemGrid xs={12}>
              <CustomInput
                labelText='API URL: where the data is pulled from'
                id='api-url'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.apiURL,
                  onChange: (e)=>this.setState({ apiURL: e.target.value })
                }}
              />
            </ItemGrid>
            {/* When daily the data should be pulled */}
            <ItemGrid xs={12}>
              <CustomInput
                labelText='Timing: when on the hour to check for updates, from 0-23 in EST'
                id='timing'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.timing,
                  onChange: (e)=>this.setState({ timing: Number(e.target.value) })
                }}
              />
            </ItemGrid>
          </Grid>
        </ModalContent>
        <ModalFooter>
          {/* Confirm create/edit */}
          <Button variant='raised'
            primary={true}
            onClick={(e) =>
              {this.state.isEditing ?
                this._onEditData(this.state.editingData)
                : this._onCreateNewData()} }>
            {this.state.isEditing ? 'Edit' : 'Create'}
          </Button>
          {/* or just cancel */}
          <Button variant='raised'
            style={{ marginLeft: 20 }}
            onClick={(e) =>
              {this.setState({ isEditing: false, showModal: false })}}>
            Cancel
          </Button>
        </ModalFooter>
      </ReactModal>
    )
  }

  renderData() {
    const {
      apis,
      isLoading,
    } = this.props;

    /* If still loading,
      display an empty table with das loading swirly */
    if (isLoading) {
      return (
        <TableRow>
          <TableCell colSpan={6}>
            <CircularProgress />
          </TableCell>
        </TableRow>
      );
    }
    // if there are no APIs yet, print and return
    else if (isEmpty(apis)) {
      return (
        <TableRow>
          <TableCell colSpan={6}>
            No data has been entered yet!
          </TableCell>
        </TableRow>
      );
    }
    // otherwise, print APIs to grid
    else {
      return (Object.values(apis).map((n) => {
        return (
          <TableRow key={n.id}>
            {/* API Abbreviation */}
            <CustomTableCell>
              {n.abrv}
            </CustomTableCell>
            {/* API fetch URL */}
            <CustomTableCell>
              {n.apiURL}
            </CustomTableCell>
            {/* Timing of pull */}
            <CustomTableCell>
              {n.timing}
              { ':00' }
            </CustomTableCell>
            {/* Edit and Delete buttons */}
            <CustomTableCell style={{display: 'flex'}}>
              <IconButton tooltip="Edit API"
                onClick={(e) => {this.initEditData(n.id)}}>
                <EditIcon />
              </IconButton>
              <IconButton tooltip="Delete API"
                onClick={(e) => {this._onDeleteData(n.id)}}>
                <DeleteIcon />
              </IconButton>
            </CustomTableCell>
          </TableRow>
        );
      }));
    }
  }

  // render function
  render() {
    // make sure only authorized Users proceed
    // check for admin rights in general
    if (!this.props.user.hasOwnProperty('admin')) {
      return (
        <Redirect from={'automation'} to={'dashboard'} key={'invalid'} />
      );
    }
    // if user has admin rights, make sure they have Master rights
    if (!this.props.user.admin.master)
    {
      return (
        <Redirect from={'automation'} to={'dashboard'} key={'disabled'} />
      );
    }
    // otherwise, return
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
      <RegularCard
        cardTitle="Automation"
        cardSubtitle="APIs to pull data from and store in organized backend."
        content={
          <Table>
            <TableHead>
              <TableRow>
                {/*Top row of content descriptors */}
  {/* Abbreviation, in the format 'state abbreviation'-'city'-'description'*/}
  {/* Any nationwide applicable data should start with 'us' */}
                <CustomTableCell>
                  Abbreviation
                </CustomTableCell>
                {/* The URL where the API data to be pulled can be found */}
                <CustomTableCell>
                  API URL
                </CustomTableCell>
                {/* How often, or when daily, the data should be fetched */}
                <CustomTableCell>
                  Pull Time
                </CustomTableCell>
                {/* Edit and Delete buttons */}
                <CustomTableCell>
                  Options
                </CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* render existing API references */}
              { this.renderData() }
              {/* render the Create/Edit data modal */}
              { this.renderModal() }
              <TableRow>
                {/* Add New button */}
                <TableCell colSpan={6}>
                  <Button style={{background: '#E5e5e5'}}
                    onClick={this._onShowModal.bind(this)}
                  >
                    Add New
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          }
      />
      </MuiPickersUtilsProvider>
    );
  }
} // end of class declaration

const mapStateToProps = (state) => {
  return {
    user: state.authReducer.user,
    apis: state.apiReducer.data,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadData: () => dispatch(loadData()),
    createNewData: (data, success, error) =>
      dispatch(createNewData(data, success, error)),
    editData: (id, data, success, error) =>
      dispatch(editData(id, data, success, error)),
    deleteData: (id, success, error) =>
      dispatch(deleteData(id, success, error)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Automation);
